$(document).ready(function() {
	
	// autocomplete form functionality
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm();
	}
	
});